import { useAuthUser } from "./auth";

type FeatureName = "reports" | "invoicing" | "scheduling" | "enrollment" | "ratio_compliance" | "photo_sharing" | "compliance_checklists" | "multi_center" | "quickbooks";

/**
 * Hook to check if a feature is enabled for the current tenant's subscription.
 * Returns true if the subscription is active and the feature is enabled.
 */
export function useFeature(feature: FeatureName): boolean {
  const { subscription } = useAuthUser();

  // If no subscription data, default to false (gated)
  if (!subscription) return false;

  // Check if subscription is active and feature is enabled
  return subscription.active && subscription.features[feature] === true;
}

/**
 * Hook to get the current subscription data.
 * Useful when you need to display subscription info or check multiple features.
 */
export function useSubscription() {
  const { subscription } = useAuthUser();
  return subscription;
}
